"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const THREE = __importStar(require("three"));
const lodash_1 = __importDefault(require("lodash"));
const applyRules_1 = __importDefault(require("../three/applyRules"));
const convertFaces_1 = __importDefault(require("../three/convertFaces"));
require("../three/orbitControls");
class Preview extends React.Component {
    constructor() {
        super(...arguments);
        this.resize = lodash_1.default.debounce(() => {
            this.resizeListener &&
                this.threeRootElement &&
                this.resizeListener(this.threeRootElement.offsetWidth, this.threeRootElement.offsetHeight);
        }, 100);
    }
    render() {
        return (React.createElement("div", { ref: element => (this.threeRootElement = element), className: this.props.asExample ? "three-container-example" : "three-container" }));
    }
    componentDidMount() {
        this.resize();
        const { setSize, updatePreview } = this.threeEntry(this.threeRootElement);
        this.resizeListener = setSize;
        this.updatePreview = lodash_1.default.debounce(updatePreview, 50);
        window.addEventListener("resize", this.resize);
        this.updatePreview(this.props.project);
    }
    componentWillUnmount() {
        window.removeEventListener("resize", this.resize);
    }
    componentWillReceiveProps({ project }) {
        this.updatePreview && this.updatePreview(project);
    }
    threeEntry(el) {
        const scene = new THREE.Scene();
        const w = el.offsetWidth || 320;
        const h = el.offsetHeight || 240;
        const camera = new THREE.PerspectiveCamera(70, w / h, 0.1, 1000);
        camera.position.z = 4;
        const controls = new THREE.OrbitControls(camera);
        const renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
        renderer.setSize(w, h);
        el.appendChild(renderer.domElement);
        // add things
        const ambientLight = new THREE.AmbientLight(0xffffff, 0.7);
        scene.add(ambientLight);
        const directionalLight = new THREE.DirectionalLight(0xffffff, 0.6);
        directionalLight.position.set(0, 1, 1);
        scene.add(directionalLight);
        let obj = null;
        const render = function () {
            requestAnimationFrame(render);
            obj && (obj.rotation.y += 0.01);
            controls.update();
            // Make any changes
            renderer.render(scene, camera);
        };
        render();
        return {
            setSize: (w, h) => {
                renderer.setSize(w, h);
                camera.aspect = w / h;
                camera.updateProjectionMatrix();
            },
            updatePreview: (project) => {
                const faceSets = applyRules_1.default(project, this.props.iterationLimit);
                if (obj !== null) {
                    scene.remove(obj);
                    obj = null;
                }
                obj = convertFaces_1.default(faceSets[this.props.iterationLimit - 1]);
                if (this.props.yOffset) {
                    console.log(this.props.yOffset);
                    obj.position.y += this.props.yOffset;
                }
                scene.add(obj);
            }
        };
    }
}
exports.default = Preview;



// WEBPACK FOOTER //
// ./src/components/editor/Preview.tsx